export const deptRules = {
  userName: [
    { required: true, message: '请输入账号', trigger: 'blur' },
    { min: 3, max: 55, message: '长度在 3 到 55 个字符', trigger: 'blur' }
  ],
  name: [
    { required: true, message: '请输入姓名', trigger: 'blur' },
    { max: 25, message: '长度不能超过 25 个字符', trigger: 'blur' }
  ],
  // jobNumber: [
  //   { required: true, message: '请输入工号', trigger: 'blur' },
  //   {
  //     pattern: /^\d{2,10}$/,
  //     message: '长度在 2 到 10 个数字'
  //   }
  // ],
  mobile: [
    { required: true, message: '请输入手机号码', trigger: 'blur' },
    {
      pattern: /^(13|14|15|16|17|18|19)[0-9]{9}$/,
      message: '手机号码填写格式不正确'
    }
  ],
  // email: [
  //   { required: true, message: '请输入电子邮箱', trigger: 'blur' },
  //   {
  //     pattern: /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
  //     message: '邮箱填写格式不正确'
  //   },
  //   { min: 3, max: 55, message: '长度在 3 到 55 个字符', trigger: 'blur' }
  // ],
  departmentStr: [
    { required: true, message: '请选择归属部门', trigger: 'change' }
  ],
  roleStr: [{ required: true, message: '请选择归属角色', trigger: 'change' }]
}

export const roleRules = {
  roleName: [
    {
      required: true,
      message: '请输入角色名称',
      trigger: 'blur'
    },
    {
      min: 2,
      max: 55,
      message: '长度在 2 到 55 个字符',
      trigger: 'blur'
    }
  ],
  departmentStr: [
    {
      required: true,
      message: '请输入部门信息',
      trigger: 'change'
    }
  ]
}
